import { render, staticRenderFns } from "./CanalesTable.vue?vue&type=template&id=11e645cc&scoped=true&lang=pug&"
import script from "./CanalesTable.vue?vue&type=script&lang=js&"
export * from "./CanalesTable.vue?vue&type=script&lang=js&"
import style0 from "./CanalesTable.vue?vue&type=style&index=0&id=11e645cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e645cc",
  null
  
)

export default component.exports